const sessionConstants = {
    MODE_QUESTION: 'question',
    MODE_SECTION: 'section',
    MODE_STRUCTURE: 'structure',
    MODE_QUESTION_SET: 'questionSet',
    CONTEXT_EXAM: 'exam',
    CONTEXT_PREVIEW: 'preview',
    CONTEXT_READINESS_CHECK: 'readinessCheck',
    CONTEXT_PREVIEW_DRAFT: 'previewDraft',
    CONTEXT_THUMBNAIL: 'thumbnail',
    CONTEXT_VIEW_DELIVERY: 'viewDelivery',
    CONTEXT_VIEW_DELIVERY_FOR_ANNOTATION_PDF: 'viewDeliveryForAnnotationPdf',
    CONTEXT_VIEW_GRADING_QUESTION_DELIVERY: 'viewGradingQuestionDelivery',
    CONTEXT_VIEW_GRADING_QUESTION_PREVIEW: 'viewGradingQuestionPreview',
    CONTEXT_VIEW_OWN_DELIVERY: 'viewOwnDelivery',
    CONTEXT_PREVIEW_AUDIO_SCRIPT: 'previewAudioScript',
    VIEW_MEDIA_PRINT: 'print',
    VIEW_MEDIA_SCREEN: 'screen',
    VIEW_MEDIA_PDF: 'pdf',
    VIEW_MEDIA_IMAGE: 'image',
    VIEW_AS_CANDIDATE: 'candidate',
    LOCK: {
        DELIVER_IN_PROGRESS: 'DELIVER_IN_PROGRESS',
        EVALUATION_IN_PROGRESS: 'EVALUATION_IN_PROGRESS',
        FILE_UPLOAD_IN_PROGRESS: 'FILE_UPLOAD_IN_PROGRESS',
        MULTIMEDIA_PLAYING: 'MULTIMEDIA_PLAYING',
        TEST_PAUSED: 'TEST_PAUSED',
    },
    SIMPLE_DATE_FORMAT: 'YYYYMMDDHHmm',
    PRINT_STYLE_STANDARD: 'standard',
    PRINT_STYLE_PAPER_BASED: 'paperBased',
    PRINT_STYLE_ANSWER_KEYS: 'answerKeys',
    ITEM_BANK_QUESTION_LEVEL: 'QUESTION',
    ITEM_BANK_SECTION_LEVEL: 'SECTION',
    CHROME_APP_TYPE: {
        PWA: 'PWA',
        CHROME_OS_APP: 'ChromeOSApp',
    },
};

module.exports = sessionConstants;
